import { render, staticRenderFns } from "./GoHomeBtn.vue?vue&type=template&id=2d94c9a5&scoped=true&"
import script from "./GoHomeBtn.vue?vue&type=script&lang=js&"
export * from "./GoHomeBtn.vue?vue&type=script&lang=js&"
import style0 from "./GoHomeBtn.vue?vue&type=style&index=0&id=2d94c9a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d94c9a5",
  null
  
)

export default component.exports